module.exports = __webpack_public_path__ + "static/media/levels.fbebd590.svg";